import { g } from "analytics";
import { P } from "apparatus/library/common";
import { AddArrow } from "arrows/command";
import { Arrow } from "arrows/type";
import { Deselect, Select } from "command/basic";
import { commandProcessor, Sequence } from "command/command";
import { Key, Tool } from "paper";
import { ID } from "store/id";
import store from "store/store";
import { crumb } from "utils";
/** Minimum length of the arrow before the arrow is shown. */
const MIN_DELTA_LENGTH_SHOW_ARROW = 20.0;
/** Arrow offset, from start to end, when no arow is shown.*/
const NO_ARROW_END_OFFSET = P(0, 15);
export default class ArrowTool extends Tool {
    constructor(layers, app) {
        super();
        /** Template arrow data to use when creating new diagrams. */
        this.templateArrow = Arrow.defaultArrow;
        this.onMouseDown = (event) => {
        };
        this.onMouseDrag = (event) => {
            this.appInterface.setArrow(this.createArrow(event, ID.TEMP_ARROW));
        };
        this.onMouseUp = (event) => {
            crumb("ui", "Add arrow");
            g("Add arrow");
            const id = ID.mint("arrow");
            let newArrowCommand = new AddArrow([this.createArrow(event, id)]);
            commandProcessor.execute(new Sequence([
                newArrowCommand,
                new Deselect(store.selectedObjectsID()),
                new Select([id]),
            ]));
            // Clean up temporary arrow.
            this.appInterface.setArrow();
        };
        this.appInterface = app;
    }
    createArrow(event, id) {
        const deltaVector = event.point.subtract(event.downPoint);
        // Checks if arrow is too short.
        const showArrow = deltaVector.length > MIN_DELTA_LENGTH_SHOW_ARROW;
        // Calculates angle of arrow.
        const angle = deltaVector.angle; //Calculates angle of arrow
        if (Key.modifiers.shift) {
            // Snaps arrow to multiples of 45 degrees.
            var roundedAngle = ((angle / 45).round()) * 45;
            deltaVector.angle = roundedAngle;
            event.point = event.downPoint.add(deltaVector);
        }
        return Object.assign(Object.assign({}, this.templateArrow), { id: id, start: event.downPoint, end: showArrow ? event.point : event.downPoint.add(NO_ARROW_END_OFFSET), showArrow: showArrow, selected: false });
    }
    updateTemplateArrow(data) {
        this.templateArrow = Object.assign(Object.assign({}, this.templateArrow), data);
    }
}
